import FileSaver from 'file-saver';
import { PAGINATION_LIMIT } from '@saucelabs/sl-util-config';
import { userService } from '@saucelabs/sl-util-axios';

import { generateReportName } from './../activity/utils';


export const getTeams = ({ limit = PAGINATION_LIMIT, offset = 0, ...rest } = {}) => (
  userService.get('/v1/teams/', {
    params: {
      limit,
      offset,
      ...rest,
    },
  })
);

export const createTeam = ({ organizationId, ...params }) => {
  const data = {
    organization: organizationId,
    ...params,
  };
  return userService.post('/v1/teams/', data);
};

export const removeTeam = ({ id }) => (
  userService.delete(`/v1/teams/${id}/`)
);

export const assignTeamToGroup = (teamId, groupId) => (
  userService.post(`/v1/groups/${groupId}/teams/`, { team_uuid: teamId })
);

export const getOrganizationTeamsUsageCSV = ({ id, name }) => (
  userService.get(`/v1/organizations/${id}/teams-activity/`, {
    headers: {
      Accept: 'text/csv',
    },
    responseType: 'blob',
  }).then(({ data }) => {
    FileSaver.saveAs(data, generateReportName({
      rootSection: name,
      reportType: 'teams',
    }));
  })
);
